import { Slide } from "@jelly/lesson";

import theory from "../../theory";
import industrialPlantNoTreatment from "./components/industrial-plant-no-treatment";
import industrialPlantAfterTreatment from "./components/industrial-plant-after-treatment";
import noiseMapNoTreatment from "./components/noise-map-no-treatment";
import noiseMapAfterTreatment from "./components/noise-map-after-treatment";

const principle: Slide = {
  description:
    "In this example you can see how a noise map changes after implemetation of various acoustic solutions on an industrial plant. In third example you can observe how acoustic screen height influence the acoustic environment of a street cross junction.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Industrial Plant" }, { name: "Noise Map" }],
        },
        {
          type: "button",
          options: {},
          items: [{ name: "No treatment" }, { name: "After treatment" }],
        },
      ],
      extraContent: [
        [[], []],
        [[], []],
      ],
      components: [
        [industrialPlantNoTreatment, industrialPlantAfterTreatment],
        [noiseMapNoTreatment, noiseMapAfterTreatment],
      ],
    },
  },
};

export default principle;
